import { ResolveFn } from '@angular/router';
import { ProfileService } from '../services';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Profile } from '../models';

export const ProfileResolver: ResolveFn<any> = (): Observable<Profile> => inject(ProfileService).loadUser();
